export const support = {
  documentation: "Documentation",
  workxConnectAppDownload: "CWorkX Connect App Download",
  contactUs: "Contact Us",
  message: "Message",
  messagePlaceHolder: "Please describe your issue in detail",
  submit: "Submit",
  pleaseInputMessage: "Please input message",
  sendSuccessfully: "Submitted successfully",
  messageMaxLength: "Support up to 2000 characters",
  versionHistory: "Version History",
};
